import { u2000FormatCivilYmdLong, u2000ShiftCivilYmd } from '../../u2000Core/tools/U2000DateTimeHelpers';

/**
 * FullCalendar fournit `end` exclusif pour les plages (datesSet / all-day).
 * Convertit en jour civil inclusif `yyyy-MM-dd` pour l'API U3301.
 */
export function u3301FcExclusiveEndToInclusiveYmd(exclusiveEndYmdOrIso: string): string | null {
  const ymd = exclusiveEndYmdOrIso.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  return u2000ShiftCivilYmd(ymd, -1);
}

/** Extrait un jour civil yyyy-MM-dd depuis une dateStr FullCalendar (all-day). */
export function u3301FcDateStrToCivilYmd(dateStr: string): string | null {
  const ymd = dateStr.trim().slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(ymd) ? ymd : null;
}

export function u3301IsHexColor(value: string): boolean {
  return /^#[0-9A-Fa-f]{6}$/.test(value.trim());
}

/**
 * Titre de période agenda (hors header FullCalendar).
 * Mois : « Juillet 2026 » ; semaine : plage inclusive dateFrom – dateTo.
 */
/**
 * Filtre catégories agenda : `[]` = toutes visibles ;
 * sinon liste explicite des catégories retenues.
 */
export function u3301ToggleCategoryFilter(
  categoryIds: string[],
  allIds: string[],
  id: string,
): string[] {
  const showingAll = categoryIds.length === 0;
  if (showingAll) {
    return allIds.filter((c) => c !== id);
  }
  if (categoryIds.includes(id)) {
    const next = categoryIds.filter((c) => c !== id);
    return next.length === 0 ? [] : next;
  }
  const next = [...categoryIds, id];
  return next.length === allIds.length ? [] : next;
}

export function u3301FormatAgendaPeriodTitle(
  viewType: string,
  anchorYmd: string,
  dateFrom: string,
  dateTo: string,
  locale?: string,
): string {
  if (viewType === 'dayGridWeek') {
    return `${u2000FormatCivilYmdLong(dateFrom, locale)} – ${u2000FormatCivilYmdLong(dateTo, locale)}`;
  }

  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(anchorYmd.trim());
  if (!m) return anchorYmd;
  const utcMs = Date.UTC(Number(m[1]), Number(m[2]) - 1, 15, 12);
  return new Intl.DateTimeFormat(locale?.trim() || undefined, {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(utcMs));
}
